import { createUseStyles } from 'react-jss';
import { ThemingParameters } from '@ui5/webcomponents-react-base';

const styles = {
  objectPage: {
    maxHeight: 'calc(100vh - 2.5rem - 0.25rem)',
    '& > header > div': {
      minHeight: 'unset',
      paddingBottom: '0'
    }
  },
  container: {
    margin: '0 15%'
  },
  title: {
    padding: '0.5rem',
    borderBottom: '1px solid var(--sapGroup_TitleBorderColor)',
    marginBottom: '1.75rem'
  },
  div: {
    display: 'flex',
    marginBottom: '1rem'
  },
  datePicker: {
    minWidth: '13.125rem'
  },
  label: {
    paddingRight: '0.3rem',
    width: '9rem',
    minWidth: '9rem',
    textAlign: 'right',
    alignItems: 'center',
    justifyContent: 'flex-end',
    display: 'inline-grid'
  },
  textAreaLabel: {
    paddingRight: '0.3rem',
    minWidth: '9rem',
    textAlign: 'right',
    alignItems: 'flex-start',
    display: 'inline-grid',
    justifyContent: 'flex-end'
  },
  secondColumnLabel: {
    paddingRight: '0.3rem',
    marginLeft: 'auto',
    minWidth: 'auto',
    alignItems: 'center'
  },
  formInput: {
    width: '30%'
  },
  formLineInput: {
    width: '100%',
    '& input': {
      flexGrow: 1
    }
  },
  formBusyIndicator: {
    width: '30%',
    '& *': {
      width: '100%'
    }
  },
  busyIndicator: {
    background: 'rgba(250, 250, 250, 0.72)',
    display: 'block'
  },
  lastContainer: { margin: '0 15%', height: '800px' },
  root: {
    backgroundColor: ThemingParameters.sapBackgroundColor,
    height: 'calc(100vh - 2.5rem - 0.25rem)'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'CreateQueryView'
});
